import { ETypeOfCharge } from "../../Enum/ETypeOfCharge"
import { BaseModel } from "../Generics/BaseModel"
import { CatalogProductEntity } from "./CatalogProductEntity"

export class ProductEntity extends BaseModel {
  id: number

  catalogProductEntity: CatalogProductEntity

  typePayment: ETypeOfCharge

  constructor(data: Partial<ProductEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.typePayment = data.typePayment ?? ETypeOfCharge.FixedValue

    this.catalogProductEntity = new CatalogProductEntity(data.catalogProductEntity)
  }
}
